import FilterRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/FilterRequest";
import SearchRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/SearchRequest";
import IFilterModel from "../IFilterModel";
import moment from 'moment';



export default class PromocodeFilterModel implements IFilterModel {
    search: string = '';
    dateFrom: Date = null;
    dateTo: Date = null;
    resetToDefault() {
        this.search = '';
        this.dateFrom = null;
        this.dateTo = null;
    }
    toSearchRequest(): SearchRequest[] {
        const res = new Array<SearchRequest>();
        this.search && res.push(new SearchRequest({FieldName: 'Code', SearchValue: this.search}));
        if (this.dateFrom) {
            const range = new SearchRequest({FieldName: 'Created', SearchFrom: moment(this.dateFrom).format('YYYY-MM-DD')});
                res.push(range);
                if (this.dateTo) {
                    range.SearchTo = moment(this.dateTo).format('YYYY-MM-DD');
                }
            }
        return res;
    }
    toFilterRequest(): FilterRequest {
        const res = new FilterRequest();
        res.Search = this.toSearchRequest();
        return res;
    }
}